<template>
    <div v-if="data" class="card mb-3 rounded-4 border-0">
        <div class="row g-0">
            <div class="col-md-5">
                <router-link :to="{'name': 'post_detail', params: { id: data.id || 0 }}">
                    <div class="blog-item-image position-relative" :style="`background: url(${data.image}) no-repeat left center; background-size: cover;`">
                        <div class="position-absolute top-0 end-0 mt-2 me-1 px-1 py-1 rounded-5 fs-7 fw-bold text-light text-center"  :style="`width: 120px; background-color: rgba(${data.category?.color}, .8)`">{{ data.category?.translate[0].name }}</div>
                    </div>
                </router-link>
            </div>
            <div class="col-md-7">
                <div class="card-body d-flex flex-column h-100">
                    <div class="card-text text-muted post-meta mb-2">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <i class="far fa-clock me-1"></i>
                                {{ G.dateToStr(data.create_date, 'news_datetime', 'datetime') }}
                            </div>
                            <span>
                                <i class="fas fa-eye me-1 small"></i>{{ data.read_count }}
                            </span>
                        </div>
                    </div>
                    <router-link class="h-100" :to="{'name': 'post_detail', params: { id: data.id || 0 }}">
                        <div class="card-title post-item-title flex-grow-1 fw-semibold" v-html="G.stripTags(data.translate && data.translate[0].title || '')"></div>
                        <div class="card-text post-item-text flex-grow-1 text-secondary" v-html="G.stripTags((data.translate && data.translate[0]?.short) || '')"></div>
                        <!-- <div class="card-text post-item-text flex-grow-1 text-secondary" v-html="G.stripTags(data.translate && data.translate[0]?.short || '').length > 170 ? G.stripTags(data.translate && data.translate[0]?.short || '').substring(0, 170) + '...' : G.stripTags(data.translate && data.translate[0]?.short || '')"></div> -->
                    </router-link>
                    <div class="blog-item-footer d-flex justify-content-between align-items-end mt-2">
                        <!-- <router-link :to="{'name': 'post_paging', params: { page: 1, perpage: G.rowsPerPage, category_id: 0, author_id: data.author?.id || 0, search_text: '' }}"> -->
                        <!-- <router-link :to="{'name': 'author_post_paging', params: { page: 1, perpage: G.rowsPerPage, author_name: data.author?.username, author_id: data.author?.id || 0, search_text: '' }}"> -->
                        <router-link :to="{'name': 'author_detail', params: { author_name: data.author?.username, author_id: data.author?.id || 0 }}">
                            <div class="d-flex align-items-center">
                                <img :src="data.author?.image" class="commenter-avatar me-3" />
                                <div>
                                    <h6 class="mb-0 btn fs-7 p-0">{{ data.author?.translate[0].firstname }} {{ data.author?.translate[0].lastname }}</h6>
                                </div>
                            </div>
                        </router-link>
                        <div>
                            <a class="text-muted btn p-0 px-1 small" v-on:click="shareLink({'name': 'post_detail', params: { id: data.id || 0 }})" :title="lang.copy"><i class="far fa-copy"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { useRouter } from 'vue-router';

import { G } from "@/_common";

export default {
    name: "BlogItemC",
    props: {
        data: {
            type: Object,
            default: () => {}
        },
        lang: {
            type: Object,
            default: () => {}
        },
    },
    setup(props) {
        const router = useRouter();

        const shareLink = (link) => {
            // let a = window.location.href;
            let a = new URL(router.resolve(link)?.href, window.location.origin)?.href;

            navigator.clipboard.writeText(a).then(() => {
                G.alert.info({msg: props.lang.success_copied, life: 1500, toast: true});
            });
        };

        return {
            G,
            shareLink,
        };
    },
}
</script>


<style lang="scss">
.post-meta {
    font-size: 0.8rem;
    color: var(--muted-text-color);
}
// .read-more-btn {
//     background-color: rgb(var(--site-primary-color-rgb));
//     color: white;
//     padding: 8px 15px;
//     border-radius: 10px;
//     font-size: 0.8rem;
//     text-decoration: none;
// }
.blog-item-image{
    height: 225px;
    border-radius: 1rem 0 0 1rem;
}
.blog-item-footer .btn:active{
    border: 0px;
    border-bottom: 1px solid black;
    border-radius: 0;
}

.post-item-title{
    display: -webkit-box;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14pt;
}
.post-item-text{
    display: -webkit-box;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
}
.commenter-avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
}

@media (min-width: 577px) and (max-width: 820px){
    .blog-item-image{
        height: 200px;
    }
    .post-item-title{
        font-size: 12pt;
        line-clamp: 1;
        -webkit-line-clamp: 1;
    }
    .post-item-text{
        line-clamp: 3;
        -webkit-line-clamp: 3;
    }
}

@media (max-width: 576px){
    .blog-item-image{
        height: 200px;
        border-radius: 1rem 1rem 0 0;
    }
    .post-item-title{
        font-size: 12pt;
        line-clamp: 2;
        -webkit-line-clamp: 2;
    }
    .post-item-text{
        line-clamp: 3;
        -webkit-line-clamp: 3;
    }
}
</style>